import React, { useState, useEffect, useRef } from "react";
import { faqItems } from "../../utility/Navigation";

const FAQSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const scrollRef = useRef(null);



  const colors = {
    primary: "#1565C0", // Dark Blue
    secondary: "#0D47A1", // Navy Blue
    light: "#0A2E5A", // Dark Navy background
    accent: "#4CAF50", // Green accent
    dark: "#0A1E3C", // Darker Navy
    textLight: "#E3F2FD", // Light text
    textDark: "#0D47A1", // Dark text
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % faqItems.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({
        left: activeIndex * scrollRef.current.offsetWidth,
        behavior: "smooth",
      });
    }
  }, [activeIndex]);

  return (
    <section
      className="d-none d-xl-block py-2 position-relative overflow-hidden"
      style={{ backgroundColor: colors.light }}
    >
      <div
        className="position-absolute top-0 start-0 w-100 h-100 opacity-10"
        style={{
          backgroundImage: "url('assets/images/bg-pattern.png')",
          backgroundSize: "cover",
        }}
      ></div>

      <div className="container position-relative py-4">
        {/* <h2
          className="text-center wow fadeInLeft fw-bold"
          style={{ color: "white", fontSize: "2.2rem" }}
          data-wow-delay="00ms"
          data-wow-duration="1500ms"
        >
          FAQ Section
        </h2>

        <h3 className="text-white text-left mb-5">
          <i
            className="fas fa-question-circle me-2"
            style={{ color: colors.accent }}
          ></i>
          Our Support Services
        </h3> */}

        {/* Carousel */}
        <div className="position-relative">
          <div
            ref={scrollRef}
            className="faq-image-scroller mx-auto d-flex"
            style={{
              width: "100%",
              overflowX: "hidden",
              scrollSnapType: "x mandatory",
              maxWidth: "1000px",
            }}
          >
            {faqItems.map((item, index) => (
              <div
                key={index}
                className="faq-slide flex-shrink-0 position-relative"
                style={{
                  width: "100%",
                  scrollSnapAlign: "center",
                  padding: "0 15px",
                }}
              >
                <div
                  className="card border-0 overflow-hidden shadow-lg"
                  style={{
                    borderRadius: "15px",
                    height: "300px",
                  }}
                >
                  <div className="row g-0 h-100">
                    <div className="col-md-6 position-relative">
                      <img
                        src={item.image}
                        alt={item.question}
                        className="img-fluid h-100 w-100 object-cover"
                      />
                      <div
                        className="position-absolute top-0 start-0 w-100 h-100"
                        style={{
                          background: `linear-gradient(to right, ${colors.primary} 0%, transparent 100%)`,
                        }}
                      ></div>
                    </div>
                    <div
                      className="col-md-6 d-flex align-items-center"
                      style={{ backgroundColor: colors.dark }}
                    >
                      <div className="p-4 p-lg-5">
                        <div
                          className="icon-circle mb-3"
                          style={{
                            width: "60px",
                            height: "60px",
                            background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.accent} 100%)`,
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "white",
                            fontSize: "1.5rem",
                            borderRadius: "50%",
                          }}
                        >
                          <i className={item.icon}></i>
                        </div>
                        <h4 className="mb-3 text-white">{item.question}</h4>
                        <p className="mb-0 text-white">{item.answer}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Dots */}
        <div className="d-flex justify-content-center mt-4">
          {faqItems.map((_, i) => (
            <button
              key={i}
              className={`btn btn-sm mx-1 ${
                activeIndex === i ? "btn-primary" : "btn-outline-primary"
              }`}
              style={{
                width: "12px",
                height: "12px",
                padding: 0,
                borderRadius: "50%",
                border: "none",
                backgroundColor:
                  activeIndex === i ? colors.accent : colors.primary,
                opacity: activeIndex === i ? 1 : 0.5,
              }}
              onClick={() => setActiveIndex(i)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
